import type { QuoteDocument } from 'paintscout'

export const PREVIEW_QUOTE_ID = 'preview'

/** Name used when the sample quote has no owner name; matches `getPresentationPreviewQuote` */
export const SAMPLE_ESTIMATOR_FIRST_NAME = 'Hugh'
export const SAMPLE_ESTIMATOR_LAST_NAME = 'Green'

export interface SampleEstimator {
  name: string
  title: string
  description: string
}

/** True for the sample quote `getPresentationPreviewQuote` builds to preview a template */
export function isPreviewQuote(quote?: Pick<QuoteDocument, '_id'> | null) {
  return quote?._id === PREVIEW_QUOTE_ID
}

/**
 * Dummy estimator for the template preview, where the sample quote has no real estimator. Named
 * after the sample quote's owner so it matches the sales rep the Work Order block shows.
 */
export function getSampleEstimator(quote?: Pick<QuoteDocument, 'owner'> | null): SampleEstimator {
  let firstName = quote?.owner?.firstName?.trim()
  let lastName = quote?.owner?.lastName?.trim()
  if (!firstName && !lastName) {
    firstName = SAMPLE_ESTIMATOR_FIRST_NAME
    lastName = SAMPLE_ESTIMATOR_LAST_NAME
  }
  const name = [firstName, lastName].filter(Boolean).join(' ')

  return {
    name,
    title: 'Estimator',
    description:
      `<p>Hi, I'm ${firstName || name}. I've been helping homeowners refresh their homes for over ten years, ` +
      `from picking the right colors to the final walkthrough.</p>` +
      `<p>I'll walk you through every step of your project, keep you updated along the way, and make sure ` +
      `the finished result is something you love coming home to.</p>` +
      `<p><em>Sample text. Each estimator's own photo and bio from their profile appear here.</em></p>`
  }
}
